interface ApiErrorWithStatus {
  status: number;
  data: unknown;
}

function hasStatus(error: object): error is ApiErrorWithStatus {
  return typeof (error as ApiErrorWithStatus).status === "number";
}

function readMessage(body: unknown) {
  const source = Array.isArray(body) ? body[0] : body;
  const message = (source as { message?: unknown } | undefined)?.message;
  return typeof message === "string" && message ? message : undefined;
}

export function getApiErrorDetail(error: unknown): string | undefined {
  if (!error || typeof error !== "object" || error instanceof Error) {
    return undefined;
  }
  if (!hasStatus(error)) {
    return readMessage(error);
  }
  if (error.status >= 500) {
    return undefined;
  }
  return readMessage(error.data);
}
